import { useState } from 'react';
import { useGoogleReCaptcha } from 'react-google-recaptcha-v3';
import { ContactSupportFormValues } from '../../../types';

type UseContactSupportFormParams = {
  onRecaptchaError: (error: unknown, values: ContactSupportFormValues) => void;
  onSubmit: (values: ContactSupportFormValues, recaptchaToken: string) => void;
};

export const useContactSupportForm = ({
  onSubmit,
  onRecaptchaError,
}: UseContactSupportFormParams) => {
  const { executeRecaptcha } = useGoogleReCaptcha();
  const [isVerifying, setIsVerifying] = useState(false);

  const handleFinish = async (values: ContactSupportFormValues) => {
    if (!executeRecaptcha) return;
    setIsVerifying(true);
    try {
      onSubmit(values, await executeRecaptcha('missing_disease'));
    } catch (error) {
      onRecaptchaError(error, values);
    } finally {
      setIsVerifying(false);
    }
  };

  return { isRecaptchaReady: !!executeRecaptcha, isVerifying, handleFinish };
};
